module.exports = __webpack_public_path__ + "static/media/PMO.fc5a53f9.pdf";